module.exports = "/assets/hero-xmas-sm@2x.png?0lsSnGt";